window.initUpload = () => {
	let upload = document.querySelector('#upload')
	if(!upload)
		return
		upload.addEventListener('change', function() {
		if (this.files && this.files[0]) {
			let img = document.querySelector('#upload-img');
			let label = document.querySelector('.upload__label');
			img.onload = () => {
				URL.revokeObjectURL(img.src);
			}

			img.src = URL.createObjectURL(this.files[0]); 
			label.classList.add('upload-file');
		}
	});

}
